import { Link } from 'react-router-dom';
import type { RemoteErrorMetadata } from './types';

interface RemoteRouteFallbackProps {
  metadata: RemoteErrorMetadata;
  message: string;
  onRetry: () => void;
}

export function RemoteRouteFallback({ metadata, message, onRetry }: RemoteRouteFallbackProps) {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="max-w-xl w-full rounded-lg border border-red-200 bg-red-50 p-6">
        <h1 className="text-xl font-semibold text-red-900">Feature temporarily unavailable</h1>
        <p className="mt-2 text-red-800">{message}</p>
        <div className="mt-2 rounded-md bg-red-100 p-3 text-xs text-red-900">
          <p>Remote: {metadata.remoteName}</p>
          <p>Route: {metadata.routePath}</p>
          <p>Correlation ID: {metadata.correlationId}</p>
        </div>
        <div className="mt-4 flex gap-3">
          <button
            type="button"
            onClick={onRetry}
            className="rounded bg-red-700 px-4 py-2 text-sm font-medium text-white hover:bg-red-800"
          >
            Retry
          </button>
          <Link
            to="/products"
            className="rounded border border-red-300 px-4 py-2 text-sm text-red-900"
          >
            Go to products
          </Link>
        </div>
      </div>
    </div>
  );
}
